/* RESPONSIBLE TEAM: team-actions */
import ApplicationSerializer from 'embercom/serializers/application';
import type McpActions from 'embercom/models/workflow-connector/mcp-actions';

const UNCATEGORIZED_ID = 'data-connectors';

export default class McpActionsSerializer extends ApplicationSerializer {
  // @ts-ignore
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    let mcpActions = payload.map((mcpAction: McpActions) => {
      return {
        id: mcpAction.mcp_server_id || UNCATEGORIZED_ID,
        type: 'workflow-connector/mcp-actions',
        attributes: {
          mcp_server_id: mcpAction.mcp_server_id,
          mcp_server_name: mcpAction.mcp_server_name,
        },
        relationships: {
          actions: {
            data: (mcpAction.actions || []).map((action: { id: any }) => ({
              id: action.id,
              type: 'workflow-connector/action',
            })),
          },
        },
      };
    });

    //  all the actions as included resources
    let includedActions = payload.flatMap((mcpAction: McpActions) =>
      (mcpAction.actions || []).map((action: { id: any }) => ({
        id: action.id,
        type: 'workflow-connector/action',
        attributes: action,
      })),
    );

    return {
      data: mcpActions,
      included: includedActions,
    };

    // @ts-ignore
    return super.normalizeResponse(...arguments);
  }
}
